/* eslint-disable max-len */

export default {
  lang: 'Dutch',
  homeScreen: {
    title: 'Dutch HomeTitle', // Product specific
    stayConnected: 'Stay Connected',
    comingSoon: 'Coming Soon',
  },
  loginScreen: {
    title: 'Travel Professional Training and Sales Enablement Program', // Product specific (TravPRO text or ChannelPRO text)
    welcome: {
      headerTop: 'Welcome to the',
      headerBottom: 'Product Sales Companion!', // Product specific
    },
    sellingPoints: { // All selling points can be product specific
      0: 'Everyday Sales Conversion Resource',
      1: 'High impact Discovery & Presentations',
      2: 'Personalize with \'favorites\' folder',
      3: 'Online, Offline - Anytime, Anywhere',
      4: 'Share, Connect, Convert',
    },
    emailPrompt: 'Please enter your email address to confirm that you are a travel professional.', // Product specific (TravPRO or ChannelPRO text)
    tAndC: {
      agree: 'By continuing you agree with our ',
      privacyPolicy: 'privacy policy',
      and: ' and ',
      termsConditions: 'terms and conditions',
    },
    fields: {
      agency: 'Agency',
      email: 'Email',
      firstName: 'First name',
      lastName: 'Last name',
      agencyName: 'Agency name',
      stateProvince: 'State / Province',
      required: 'Required',
      invalidEmail: 'Invalid email address',
      optInMarketing: 'Opt in to marketing emails',
      opt: 'Stay In Touch! Yes, I\'d like to opt in to communications from Product that will keep me posted on news, events, incentives, FAM’s and more!', // Product specific
    },
    noAgent: {
      noAgentButton: 'I\'m not an agent',
      title: 'Thank you for your interest in Product.', // Product specific
      messageWeb: 'The content on this site is exclusively for travel professionals. \n To learn more about the Product, please visit: ', // Product specific
      messageMobile: 'Some content on this app is exclusively for travel professionals, but feel free to browse a preview of what this app has to offer by pressing \'Continue\'.', // Product specific
      continue: 'Continue',
      visitWebsite: 'Visit website',
    },
    newUser: 'New User',
    register: 'Register',
  },
  welcomeScreen: {
    title: 'Welcome to the\nProduct Training Program and Sales Companion', // Product specific
    helloUser: 'Hello {name}',
    hello: 'Hello,',
    fromAgency: 'from {agency}',
    notUser: 'Not {name}?',
    introOnline: 'Train immediately online or preload the content so it\'s always available for offline use!',
    introOffline: 'You already have the latest version preloaded. Start training or selling anytime, anywhere!',
    startTraining: 'Start training',
    downloader: {
      preload: 'Preload',
      stop: 'stop',
      init: 'Initializing...',
      lastUpdate: 'Last update: ',
    },
  },
  trainingScreens: {
    start: 'Start',
    continue: 'Continue',
    restart: 'Restart',
    durationInMinutes: '{number} minutes',
    percentageComplete: '{number}% Complete',
    unlock: 'Unlock this chapter by completing training chapter {number}.',
    unlockSubtitle: 'Unlock more chapters by completing training chapters.',
    allUnlocked: 'You have unlocked all chapters!',
    certificate: 'Certificate',
    courseComplete: 'Course complete!',
    endReached: 'You\'ve reached the end',
    retainEnd: 'Use the top bar to navigate around in this chapter or press the back button to return to the overview.',
    watchListenRead: 'Watch, Listen & Read more',
    trouble: 'It looks like you\'re having trouble, would you like to skip this question?',
    incorrect: 'Sorry! That\'s incorrect.',
    mistake: 'mistake',
    mistakes: 'mistakes',
    tooManyMistakes: 'You\'ve made 3 mistakes. We recommend you visit the training section for more training.',
    confirm: 'Confirm your answer',
    choose: 'Please choose an answer',
    skip: 'Skip question',
    next: 'Next question',
    retry: 'Try Again',
    fastTrackText: {
      success: "Congratulations, you've passed the Fast Track course and unlocked the rest of the training!",
      failed: "Unfortunately you didn't pass the Fast Track course, you can resume your training to earn your diploma!",
    },
    fastTrack: 'Would you like to enter the Fast Track course?',
    fastTrackExplanation: 'Are you a {appName} expert already? The Fast Track is a condensed course to test your knowledge. Passing this course will let you bypass the regular training.',
    fastTrackButton: 'Fast Track',
    grading: 'Your final grade is a{n} {grade}',
  },
  nav: {
    home: 'Home',
    train: 'Train',
    retain: 'Retain',
    directory: 'Directory',
    promote: 'Promote',
    sell: 'Sell',
    info: 'Info',
    media: 'Media',
    favorites: 'Favorites',
    contact: 'Contact',
    reportCard: 'Report Card',
    accountSettings: 'Account Settings',
    messages: 'Messages',
    search: 'Search',
  },
  contentHeaders: {
    train: 'Training Library',
    retain: 'Retain',
    subapps: 'Partner Specialist Programs',
  },
  sharing: {
    copyURL: 'Copy link',
    copied: 'Copied!',
  },
  pageDescriptions: {
    train: 'Training allows you to learn the Essentials to become a great Travel Advisor.',
    retain: 'Explore all content to reinforce your knowledge',
    promote: 'Media Assets Organized for Easy Access and Sharing',
    sell: 'Easy Access To Sales Collateral.',
    favorites: 'Check out your personally favorited content',
    search: 'Look through all content',
    subapps: 'Learn more from our partners',
  },
  general: {
    next: 'Next',
    previous: 'Previous',
    submit: 'Submit',
    back: 'Back',
    close: 'close',
    yes: 'Yes',
    no: 'No',
    page: 'Page',
    search: 'Search',
    logIn: 'Log in',
    logOut: 'Log Out',
    viewItem: 'View {type}',
    imageNotFound: 'Image not found',
    noResultsFor: 'No results have been found for: {{query}}',
    noFavorites: 'You don\'t have any favorites yet.',
    noMessages: 'You haven\'t received any messages yet!',
    resultsFor: 'Results for: {query}',
    showAll: 'Show all',
    connectionError: 'Connection error',
    alreadyExists: 'Already exists',
    pageNotFound: '404 Page Not Found!',
    oops: 'Uh oh...',
    overview: 'Return to overview',
    courseComplete: 'Course Complete!',
    chapterComplete: 'Chapter Complete!',
    message: '{count} Message',
    messagePlural: '{count} Messages',
  },
  messageCenter: {
    dayAgo: '1 day ago',
    monthAgo: '1 month ago',
    yearAgo: '1 year ago',
  },
  itemTypes: {
    image: 'Image',
    brochure: 'Collection',
    layout: 'Layout',
    web: 'Website',
    pdf: 'PDF',
    carousel: 'Collection',
  },
  collectionView: {
    main: 'Home',
    sell: 'Sell',
    promote: 'Promote',
  },
  questions: {
    dials: 'Rotate the dials to match the answer',
    fitb: 'Fill in the blank(s)',
    flip: 'Change the number to match the answer',
    multipleChoice: 'Pick the right answer(s)',
    slider: 'Pick the right answer using the slider',
    map: 'Answer the question by tapping the right location on the map',
    dropdown: 'Choose...',
    true: 'True',
    false: 'False',
  },
  reportCard: {
    download: 'Download',
    email: 'Email',
    print: 'Print',
    confirm: 'Close',
  },
  cookies: {
    consent: 'AGREE',
    optout: 'Opt-out',
    settings: 'Privacy Settings',
    message: "You haven't told us anything about your data privacy preferences! That's ok, but we'd like to offer you the best experience using the Sales Companion.",
    disabled: 'It looks like you have disabled the use of cookies.',
    use: 'The {{appName}} requires the use of cookies to deliver you the best experience.',
    details: 'What are the cookies used for?',
    enable: 'See how to enable your cookies {{here}}.',
    here: 'here',
  },
  notLoggedIn: {
    super: "You're not logged in",
    title: 'You need to be logged in to view this content',
    guest: 'Guest',
  },
  demo: {
    message: 'This website is a demo of the final product. It is currently in-development and not a complete product.',
    consent: 'Understood!',
  },
  share: {
    header: 'Share this resource:',
    download: 'download',
  },
  errors: {
    comingSoon: 'Coming soon...',
    missingContent: 'The requested content is still in production.',
  },
  breadCrumbs: {
    page: 'Page',
  },
  onMobile: {
    header: 'It looks like you\'re trying to access the {appName} app from a mobile device',
    body: 'To download this program simply visit your app store and search for {appName} or click one of the buttons below',
    benefits: {
      header: 'This will provide you with:',
      1: 'Portability',
      2: 'No need for WiFi, train when and where convenient',
      3: 'Sales tools & resources at your fingertips',
    },
    continue: 'Continue anyway',
  },
  points: {
    pointsToLevel: '{pointsToLevel} {points} until you have reached the {rank} ranking!',
    outOf: '{points} XP out of',
    pointsToRank: '{pointsToLevel}XP needed to rank:  ({rank})',
  },
};
